(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image-text-qoute"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initIts(root) {
      if (!root || root.dataset.itsReady === '1') return;
      root.dataset.itsReady = '1';

      var slides = root.querySelectorAll('.cc-image-text-qoute__slide');
      var dots = root.querySelectorAll('.cc-image-text-qoute__dot');
      if (slides.length < 2) return;

      var current = 0;
      var timer = null;
      var autoplay = root.dataset.autoplay === 'true';
      var speed = (parseFloat(root.dataset.speed) || 5) * 1000;

      function go(i) {
        i = (i % slides.length + slides.length) % slides.length;
        if (i === current) return;
        slides[current].classList.remove('is-active');
        slides[current].setAttribute('aria-hidden', 'true');
        if (dots[current]) dots[current].classList.remove('is-active');
        current = i;
        slides[current].classList.add('is-active');
        slides[current].setAttribute('aria-hidden', 'false');
        if (dots[current]) dots[current].classList.add('is-active');
      }

      function start() {
        if (!autoplay) return;
        stop();
        timer = setInterval(function () { go(current + 1); }, speed);
      }
      function stop() {
        if (timer) { clearInterval(timer); timer = null; }
      }

      dots.forEach(function (d, i) {
        d.addEventListener('click', function () { go(i); start(); });
      });

      var dragX = null;
      var area = root.querySelector('.cc-image-text-qoute__slides');
      area.addEventListener('pointerdown', function (e) { dragX = e.clientX; });
      document.addEventListener('pointerup', function (e) {
        if (dragX === null) return;
        var dx = e.clientX - dragX;
        dragX = null;
        if (Math.abs(dx) > 40) { go(current + (dx < 0 ? 1 : -1)); }
        start();
      });
      area.addEventListener('pointercancel', function () { dragX = null; });

      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);

      root._itsGo = go;
      root._itsStop = stop;
      root._itsStart = start;

      start();
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('.cc-image-text-qoute').forEach(initIts);
    }

    function activateSlide(slide) {
      var wrap = slide.parentNode;
      var idx = Array.prototype.indexOf.call(wrap.children, slide);
      var root = slide.closest('.cc-image-text-qoute');
      if (root && root._itsGo) {
        root._itsGo(idx);
        root._itsStop();
        return;
      }
      // Fallback (e.g. single slide or not yet initialised)
      wrap.querySelectorAll('.cc-image-text-qoute__slide').forEach(function (s) {
        var on = s === slide;
        s.classList.toggle('is-active', on);
        s.setAttribute('aria-hidden', on ? 'false' : 'true');
      });
    }

    if (document.readyState !== 'loading') {
      initAll();
    } else {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    }

    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });

    /* Theme editor: reveal & edit the slide whose block is selected */
    document.addEventListener('shopify:block:select', function (e) {
      var slide = e.target && e.target.closest ? e.target.closest('.cc-image-text-qoute__slide') : null;
      if (slide) activateSlide(slide);
    });
    document.addEventListener('shopify:block:deselect', function (e) {
      var slide = e.target && e.target.closest ? e.target.closest('.cc-image-text-qoute__slide') : null;
      if (!slide) return;
      var root = slide.closest('.cc-image-text-qoute');
      if (root && root._itsStart) root._itsStart();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kopstorm-section-3"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function build(root) {
      if (root.dataset.swiperReady === '1') return true;

      var el = root.querySelector('.trustpilotV2');
      if (!el) {
        root.dataset.swiperReady = '1';
        return true;
      }
      if (typeof Swiper === 'undefined') return false;

      root.dataset.swiperReady = '1';
      var sectionId = root.dataset.sectionId;
      var autoplay = root.dataset.autoplay === 'true';
      var speed = (parseFloat(root.dataset.speed) || 5) * 1000;
      var prevEl = document.getElementById('tp-prev-' + sectionId);
      var nextEl = document.getElementById('tp-next-' + sectionId);

      var swiper = new Swiper(el, {
        slidesPerView: 1,
        spaceBetween: 15,
        loop: root.dataset.loop !== 'false',
        grabCursor: true,
        autoplay: autoplay
          ? { delay: speed, pauseOnMouseEnter: true, disableOnInteraction: false }
          : false,
        breakpoints: {
          768: { slidesPerView: 2, spaceBetween: 15 },
          1024: { slidesPerView: 3, spaceBetween: 15 }
        }
      });

      if (nextEl) {
        nextEl.addEventListener('click', function () {
          swiper.slideNext();
        });
      }
      if (prevEl) {
        prevEl.addEventListener('click', function () {
          swiper.slidePrev();
        });
      }

      return true;
    }

    function initAll(scope) {
      var ready = true;
      (scope || document).querySelectorAll('.trustpilot-V2').forEach(function (r) {
        if (!build(r)) ready = false;
      });
      return ready;
    }

    function boot() {
      if (!initAll()) setTimeout(boot, 120);
    }

    if (document.readyState !== 'loading') {
      boot();
    } else {
      document.addEventListener('DOMContentLoaded', boot);
    }

    document.addEventListener('shopify:section:load', function (e) {
      initAll(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["text-with-icons"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function build(el) {
      if (el.dataset.twiReady === '1') return true;
      if (typeof Swiper === 'undefined') return false;

      el.dataset.twiReady = '1';
      var dots = el.parentNode.querySelector('.text-with-icons__pagination');
      var desktop = parseInt(el.getAttribute('data-desktop-slides'), 10) || 5;

      new Swiper(el, {
        slidesPerView: 1.15,
        spaceBetween: 16,
        grabCursor: true,
        watchOverflow: true,
        rewind: true,
        pagination: dots ? { el: dots, clickable: true } : false,
        breakpoints: {
          700: { slidesPerView: 3, spaceBetween: 20 },
          1150: { slidesPerView: desktop, spaceBetween: 20 }
        }
      });
      return true;
    }

    function initAll(scope) {
      var ready = true;
      // Target the carousel element directly (unique descendant) so shopify:section:load
      // re-init works (the wrapper's own schema class is not matchable via querySelectorAll on itself).
      (scope || document).querySelectorAll('.text-with-icons__carousel').forEach(function (el) {
        if (!build(el)) ready = false;
      });
      return ready;
    }

    function boot() { if (!initAll()) setTimeout(boot, 120); }

    if (document.readyState !== 'loading') { boot(); }
    else { document.addEventListener('DOMContentLoaded', boot); }

    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
